import { createDeferredProjectQuote } from "./createDeferredProjectQuote";
export const DeferredProjectQuote = createDeferredProjectQuote(() =>
  import("./CostedProjectQuote").then((m) => ({ default: m.ProjectQuote })),
);
